/**
 * Ð¤Ð¾Ñ€Ð¼Ð¸Ñ€ÑƒÐµÑ‚ Ð°Ñ‚Ñ€Ð¸Ð±ÑƒÑ‚ rel Ð´Ð»Ñ ÑÑÑ‹Ð»ÐºÐ¸
 * @param {string} location
 */
export const getRel = location => {
    let rel = ['nofollow'];

    if (/^https?:/.test(location)) {
        rel.push('noopener');
    }

    return rel.join(' ');
};

/**
 * ÐŸÐ¾Ð»ÑƒÑ‡Ð°ÐµÑ‚ ÑÑÑ‹Ð»ÐºÑƒ Ð½Ð° Ð¼ÐµÑ‚Ð°-Ñ‚ÑÐ³
 * @param {string} name
 * @param {string} value
 */
export const getMetaTag = (name, value) => document.querySelector(`meta[${name}="${value}"]`);

/**
 * ÐŸÐ¾Ð»ÑƒÑ‡Ð°ÐµÑ‚ ÑÑÑ‹Ð»ÐºÑƒ Ð½Ð° Ð¼ÐµÑ‚Ð°-Ñ‚ÑÐ³ og-Ñ€Ð°Ð·Ð¼ÐµÑ‚ÐºÐ¸
 * @param {string} name
 */
export const getOgTag = name => getMetaTag('property', `og:${name}`);
